module.exports = __webpack_public_path__ + "27d3f3f4ed55df47d71650e7863badf2.svg";